module.exports = __webpack_public_path__ + "images/icon_bet_minus_wca_ab511c11e1bab7725864aa0876503639.svg";